import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../../components/Header";
import { useContext } from "react";
import { AuthContext } from "../../utils/AuthContext";
import toast from "react-hot-toast";

function Checkout() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { user } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [loadingReserve, setLoadingReserve] = useState(null);
  const navigate = useNavigate()
  



  const roomId = params.get("room");
  const checkIn = params.get("checkIn");
  const checkOut = params.get("checkOut");

  const [room, setRoom] = useState(null);
  const [total, setTotal] = useState(null);

  useEffect(() => {
  if (!user) return;

  const fetchUser = async () => {
    try {
      const res = await axios.get(
         `https://api.komorotel.com/api/user/${user?._id}`,
        { withCredentials: true }
      );

      setUserData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  fetchUser();
}, [user]);

  // 🔥 fetch room
  useEffect(() => {
    const fetchRoom = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/rooms/${roomId}`
        );
        setRoom(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchRoom();
  }, [roomId]);

  // 🔥 fetch total price
  useEffect(() => {
    if (!checkIn || !checkOut) return;

    const fetchPrice = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/tarifs/calculate-room-price`,
          {
            params: { roomId, startDate: checkIn, endDate: checkOut },
          }
        );

        setTotal(res.data.total);
      } catch (err) {
        console.log(err);
      }
    };

    fetchPrice();
  }, [roomId, checkIn, checkOut]);

  const nights =
    checkIn && checkOut
      ? Math.ceil(
          (new Date(checkOut) - new Date(checkIn)) /
            (1000 * 60 * 60 * 24)
        )
      : 0;

  const handleReserve = async () => {
  try {
    setLoadingReserve(true);

    const res = await axios.post(
      "https://api.komorotel.com/api/reservation",
      {
        roomId,
        checkInDate: checkIn,
        checkOutDate: checkOut,
      },
      { withCredentials: true }
    );

    // 🔥 UX immédiate + transition
    navigate("/confirmation/" + res.data.reservationId);

  } catch (err) {
    console.log(err);
    toast.error(err.response?.data?.message || "Une erreur est survenue");
  } finally {
    setLoadingReserve(false);
  }
};

  return (
    <>
        <Header/>
        <div className="max-w-6xl mx-auto py-10 px-4 mt-6">

        <h1 className="text-2xl font-semibold mb-8">
            Finaliser la réservation
        </h1>

        <div className="grid md:grid-cols-2 gap-10">

            {/* 🔵 LEFT = RÉSUMÉ */}
            <div className="bg-white border rounded-2xl p-6">

            <h2 className="text-lg font-semibold mb-4">
                Votre séjour
            </h2>

            {room && (
                <>
                <p className="font-medium text-gray-900">
                    {room.title}
                </p>

                <p className="text-sm text-gray-500 mt-1">
                    {checkIn} → {checkOut}
                </p>

                <p className="text-sm text-gray-500">
                    {nights} nuit{nights > 1 && "s"}
                </p>
                </>
            )}

            <div className="mt-6 border-t pt-4">

                <div className="flex justify-between text-sm">
                <span>Prix total</span>
                <span className="font-semibold">
                    {total ? `${total}€` : "..."}
                </span>
                </div>

            </div>

            </div>

            {/* 🟢 RIGHT = FORM */}
            <div className="bg-white border rounded-2xl p-6">

            <h2 className="text-lg font-semibold mb-4">
                Informations client
            </h2>

            <div className="flex flex-col gap-3">

               <input
                  defaultValue={userData?.surname || ""}
                  placeholder="Nom"
                  className="border rounded-lg px-3 py-2 text-sm"
                />

                <input
                  defaultValue={userData?.name || ""}
                  placeholder="Prénom"
                  className="border rounded-lg px-3 py-2 text-sm"
                />

              <input
                defaultValue={userData?.email || ""}
                placeholder="Email"
                className="border rounded-lg px-3 py-2 text-sm"
              />

              <input
                defaultValue={userData?.phone || ""}
                placeholder="Téléphone"
                className="border rounded-lg px-3 py-2 text-sm"
              />

              {user && (
                <p className="text-xs text-gray-500 mb-3">
                  Vos informations sont pré-remplies
                </p>
              )}

            </div>

            <button
                className="
                mt-6 w-full py-3 rounded-xl
                bg-[#3A9D23] text-white font-medium
                hover:bg-[#33891E] transition
                "
                onClick={handleReserve}
            >
                Confirmer la réservation
            </button>

            </div>

        </div>

        </div>
    </>
  );
}

export default Checkout;